import { cleanLoyaltyInfo, cleanRegistryInfo, cleanSignInForDevMode } from '~/utils/signOut';

export default async function useSignOutClick(isMcom) {
  cleanLoyaltyInfo(isMcom);
  cleanRegistryInfo();
  cleanSignInForDevMode();
}
